import { render } from "./carousel-modal.vue?vue&type=template&id=3cacfd85"
import script from "./carousel-modal.vue?vue&type=script&lang=js"
export * from "./carousel-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__